/**
   * element.substrate-toggle.js — keeps the Plakat/Lærred twin link pointing at
   * the twin variant that matches the currently selected size (and refreshes the
   * little price hint on the tile).
   *
   * Loaded ONCE, globally, from layout/theme.liquid — NOT from the snippet.
   * Quick view fills the modal with fetch() + innerHTML, and <script> tags
   * injected that way never execute; document-level event delegation needs no
   * per-instance init, so injected modal markup just works.
   */
  (function () {
    if (window.__substrateToggleInit) return;
    window.__substrateToggleInit = true;

    function parse(raw) {
      try {
        return JSON.parse(raw || '{}');
      } catch (err) {
        return {};
      }
    }

    document.addEventListener('change', function (e) {
      var input = e.target;
      // Classic-Impulse markup: radios (variant-button.liquid) and selects
      // (variant-dropdown.liquid) carry data-index="optionN" but no
      // data-variant-input attribute.
      if (!input || !input.matches || !input.matches('input[type="radio"][data-index="option1"], select[data-index="option1"]')) return;

      // PDP/quick-shop wrapper has class "product-section"; the featured-product
      // section wrapper only carries data-section-type="product".
      var section = input.closest('.product-section, [data-section-type="product"]');
      if (!section) return;

      var toggle = section.querySelector('substrate-toggle');
      if (!toggle) return;

      var link = toggle.querySelector('a[data-substrate-link]');
      if (!link) return;

      var size = input.value;
      var urls = parse(toggle.getAttribute('data-size-urls'));
      var prices = parse(toggle.getAttribute('data-size-prices'));

      if (urls[size]) link.setAttribute('href', urls[size]);

      var priceEl = link.querySelector('[data-substrate-price]');
      if (priceEl) priceEl.textContent = prices[size] || '';
    });
  })();